import React, { useState, useMemo } from "react";
import moment from 'moment';
import ReactJson from 'react-json-view';
import FileCopyIcon from '@mui/icons-material/FileCopy';
// import { masterDataSelector } from "../../../store/slices/masterData"
import { useDispatch, useSelector } from "react-redux";

import {
    Drawer, Divider, CardContent, Typography, DialogTitle, Stack, useTheme,
    IconButton, Box, Switch, Tabs, Tab, Tooltip, Select, MenuItem
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { convertArrayToDictionary} from "../../../common/utils";
import { locationsSelector } from "../../../store/slices/location";
import MainCard from "../common/mainCard";

const LogDrawerCard = ({ usage, height }) => {

    const [view, setView] = useState(1);
    const { users } = useSelector(locationsSelector);
    const tabChange = (event, newValue) => {
        setView(newValue);
    };
    const getOutPut = (output) => {
        let jObject;
        try {

            jObject = JSON.parse(output);
        } catch (e) {
            jObject = output; // error in the above string (in this case, yes)!
        }
        return jObject
    }
    const getUserName = (userId) => {
        const user = userDic[userId];
        return user?.firstName?('by '+user?.firstName + (user?.lastName ? (' ' + user?.lastName) : '')):''
    }
    const handleLogCopy = (data) => {
        const finalObj = {
            Input: JSON.parse(data?.input),
            Output: JSON.parse(data?.output)
        }
        const stringData = JSON.stringify(finalObj, undefined, 2)
        return navigator.clipboard.writeText(stringData)
    }
    const userDic = React.useMemo(() => convertArrayToDictionary(users, 'userId'), [users])
    const output = React.useMemo(() => getOutPut(view === 1 ? usage.input : usage.output), [view, usage]);
    return (<Stack direction={'column'} spacing={1} key={usage.GPTUsageId}>

        <Stack direction={'row'} alignItenms={'baseline'} justifyContent={'left'} spacing={1}>
            <AccessTimeIcon />
            <Typography variant="subtitle1" gutterBottom>
                {moment(moment.utc(usage.createdOn).toDate()).format('YYYY-MM-DD HH:mm:ss')} {getUserName(usage.createdBy)}
            </Typography>
        </Stack>

        {/* Input Text */}
        <MainCard elevation={2} headers={{ py: 0.5, pb: 0 }} contentSX={{ paddingRight: 0 }} title={
            <Tabs onChange={tabChange} value={view} sx={{ height: '20px' }}>
                <Tab value={1} label="Input" />
                <Tab value={2} label="Output" />
            </Tabs>
        }
            secondary={<Tooltip title='Copy to clipboard' arrow disableInteractive><span><IconButton onClick={() => handleLogCopy(usage)}>
                <FileCopyIcon />
            </IconButton></span></Tooltip>
            }
        >
            <Typography variant="body1" gutterBottom sx={{ whiteSpace: 'pre-wrap', height: height, overflow: 'auto' }}>
                {/* {output} */}
                {typeof output === "string" && output}
                {typeof output !== "string" &&
                    <ReactJson key={'logdrawer'} displayDataTypes={false} name={false} src={output} enableClipboard={false} />
                }
                {/* {view === 1 ? usage.input : usage.output} */}
            </Typography>
        </MainCard>
        {/* Output Text */}
        {/* <MainCard title='Output'>
                    <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }} >
                      {String(usage.output).replaceAll(/\\"/g, '"').split('\\n').map((item, i) => <Typography variant='body1' key={i}>{item}</Typography>)}
                    </Typography>
                  </MainCard> */}
    </Stack>
    )
}
export default LogDrawerCard;
